import * as React from 'react'
import { graphql } from 'gatsby'

import { get_optional_field, get_labelled_field, format_date} from '../uglib_utils/utils'

import * as styles from '../uglib_styles/collectionUpdate.module.css';
import Layout from '../uglib_components/layout';


const CollectionUpdate = ( props ) => {
	const data = props.data.collections.nodes[0];
	
	const breadcrumbs = [
		{ 
			url: "",
			title: "Find",
		},
		{ 
			url: "/find/collections",
			title: "Our Collectionss",
		},
		{ 
			url: "/find/collections/collection-updates",
			title: "Collection Updates",
		},
	]

	const title = data.title;
	const body = get_optional_field(data, 'body.processed');

	// Cancellations
	let resource_title = <></>;
	let resource_cost = <></>;
	let cancellation = <></>;
	let cancellation_date_rendered = <></>;
	let alternative_resources = <></>;
	let cancellations_rendered = <></>
	
	resource_title = get_labelled_field(get_optional_field(data, 'field_cu_title_of_resource'), <h2 className={styles.field_label}>Resource title</h2>);
	resource_cost = get_labelled_field(get_optional_field(data, 'field_cu_cost'), <h2 className={styles.field_label}>Cost of resource</h2>);
	cancellation = get_labelled_field(get_optional_field(data, 'field_cu_reasons.processed'), <h2 className={styles.field_label}>Reasons for cancellation</h2>);
	let cancellation_date = format_date(get_optional_field(data, 'field_cu_cease_date'));
	cancellation_date_rendered = get_labelled_field(cancellation_date, <h2 className={styles.field_label}>Date access will cease</h2>);
	alternative_resources = get_labelled_field(get_optional_field(data, 'field_cu_alternate_resources.processed'), <h2 className={styles.field_label}>Alternative resources</h2>);

	cancellations_rendered = <>
		{ /**** Cancellations ****/}
		{ /**** Legacy body field ****/}
		<div dangerouslySetInnerHTML={{__html: body}} />

		{resource_title}
		{resource_cost}
		{cancellation}
		{cancellation_date_rendered}
		{alternative_resources}
	</>


    return (
      <Layout breadcrumbs={breadcrumbs} title={title} bodyClass='collection-update'>
		  	
		<div>{cancellations_rendered}</div>

      </Layout>
    )
}

export const query = graphql`
  	query ($id: String) {
		collections: allNodeCollectionUpdate(filter: {id: {eq: $id}}) {
			nodes {
				created
				field_cu_year
				field_cu_title_of_resource
				field_cu_cease_date
				field_cu_cost
				field_cu_reasons {
				  	processed
				}
				id
				path {
				  	alias
				}
				title
				field_cu_alternate_resources {
				  	processed
				}
				relationships {
					field_news_story_image {
						id
						localFile {
							childImageSharp {
								gatsbyImageData(width: 300)
							}
						}
					}
				}
				body {
					processed
				}
			}
		}
		
  	}
`

export default CollectionUpdate